import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { Job, JobBids, JSONApiDataObject, ReduxEntity } from 'Douleutaras/types';
import { RootState } from 'Douleutaras/redux/store';

const jobBidsFeedbackAdapter = createEntityAdapter<JSONApiDataObject<JobBids>>({
  selectId: item => item.id
});

export const jobBidsFeedbackSlice = createSlice({
  name: 'jobBidsFeedback',
  initialState: jobBidsFeedbackAdapter.getInitialState({
    loading: false,
    error: false,
    meta: {},
    entities: {}
  } as ReduxEntity<JSONApiDataObject<Job>>),
  reducers: {
    jobBidsFeedbackAdded: (state, action) => {
      jobBidsFeedbackAdapter.setMany(state, action.payload);
    }
  }
});

export const jobBidsFeedbackSelectors = jobBidsFeedbackAdapter.getSelectors(
  (state: RootState) => state.jobBidsFeedback);
